module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-McKay-Web-1280.2f6babcd.jpg";